<template>
  <div class="newbie" v-if="listType !== null" @mouseenter="onBlur(true)" @mouseleave="onBlur(false)">
    <div class="title defaultFamily">{{$t('home_v2_92')}}</div>
    <div class="tab">
      <div class="tab-swiper">
        <div class="swiper-wrapper tab">
          <div class="swiper-slide tabItem" v-for="item in listType" :key="item.id" @click="courseTypeId = item.id" :class="{'click': item.id === courseTypeId}">
            {{item.content}}
          </div>
      </div>
    </div>
    </div>
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in list" :key="item.id" @click.stop="push(item.url)">
          <div class="background"></div>
          <img :src="item.coverImgUrl" alt="">
          <p class="twoline">{{item.content}}</p>
          <div class="bottom">
            <p>{{item.type === 1 ? $t('home_v2_153') : item.type === 2 ? $t('home_v2_152') : 'FAQ'}}</p>
            <svg class="twoLineIcon ficon" v-if="item.type === 1">
              <use xlink:href="#bf-todo-line" />
            </svg>
            <svg class="twoLineIcon ficon" v-else-if="item.type === 2">
              <use xlink:href="#bf-youtube-line" />
            </svg>
            <svg class="twoLineIcon ficon" v-else>
              <use xlink:href="#bf-question-line" />
            </svg>
            <!-- <img src="./Vector(5).png" alt="" v-if="item.type === 1" style="width:12px;height:14px;">
            <img src="./Vector(6).png" alt="" v-else-if="item.type === 2" style="width:13px;height:10px;">
            <img src="./Vector(8).png" alt="" v-else style="width:13px;height:10px;"> -->
          </div>
        </div>
      </div>
      <div class="swiper-button-next next" v-show="arrowShow"><img src="./Vector (7).png" alt=""></div>
      <div class="swiper-button-prev next" v-show="arrowShow"><img src="./Vector (7).png" alt=""></div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import {getCourseList, getCourseListType} from '~/model/clientAcademyModel.js';
import { mapState } from 'vuex';
export default {
  name: 'WwwBitforexCom20Index',

  data () {
    return {
      arrowShow: false,
      courseTypeId: 1,
      listType: [],
      list: [],
      config: {
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'my-button-disabled'
        },
        on: {
          slideChangeTransitionEnd: function () {
            console.log(this.isEnd);
            if (this.isEnd) {
              this.navigation.$nextEl.css('display', 'none');
            } else {
              this.navigation.$nextEl.css('display', 'flex');
            };
            if (this.isBeginning) {
              this.navigation.$prevEl.css('display', 'none');
            } else {
              this.navigation.$prevEl.css('display', 'flex');
            };
          }
        }
      },
      config1: {
        slidesPerGroup: 1,
        spaceBetween: 24,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true
      }
    };
  },

  mounted () {
    this.getCourseListType();
    // this.$nextTick(() => {
    //   let swiper = new Swiper('.swiper', this.config);
    //     swiper.on('click', this.onClickSlider);
    // });
  },
  watch: {
    courseTypeId () {
      this.getCourseList();
    }
  },
  computed: {
    ...mapState({
      locale: state => state.common.locale
    })
  },
  methods: {
    onBlur (value) {
      this.arrowShow = value;
    },
    async getCourseListType () {
      const res = await getCourseListType({lang: this.locale === 'pt-br' ? 'pt' : this.locale});
      if (res.success) {
        if (res.data.length === 0) {
          this.listType = null;
        } else {
          this.listType = res.data;
          this.courseTypeId = res.data[0].id;
          this.getCourseList();
        }
        let swiperss = new Swiper('.tab-swiper', this.config1);
        swiperss.on('.tab-swiper');
      }
    },
    async getCourseList () {
      const res = await getCourseList({lang: this.locale === 'pt-br' ? 'pt' : this.locale, courseTypeId: this.courseTypeId});
      if (res.success) {
        if (res.data.length === 0) {
          this.list = null;
        } else {
          this.list = res.data;
        }
        let swiper = new Swiper('.swiper', this.config);
        swiper.on('.swiper');
      }
    },
    onClickSlider (a, e) {
    },
    push (item) {
      window.open(item);
    }
  }
};
</script>

<style lang="scss" scoped>

  .newbie{
    padding-left: 16px !important;
    padding-right: 16px !important;
    width: 100%;
    overflow: hidden;
    position: relative;
    .swiper{
      --swiper-navigation-size: 0;
    }
    .next{
      width: 40px;
      height: 40px;
      background: white;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.2);
      border-radius: 24px;
      opacity: 1;
      top: 60%;
    }
    .swiper-button-prev{
      transform:rotate(180deg);
    }
    .my-button-disabled{
      display: none;
    }
    .title{
      font-style: normal;
      font-weight: 500;
      font-size: 40px;
      line-height: 120%;
      letter-spacing: -0.02em;
      color: #0E0E2C;
    }
    .tab{
      margin-top: 44px;
      margin-bottom: 36px;
      .tabItem:nth-child(1){
        margin-left: 0px;
      }
      .tabItem{
        width: auto !important;
        margin-left: 40px;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 134%;
        letter-spacing: -0.02em;
        color: #0E0E2C;
        cursor: pointer;
        &.click{
          color: #14C393;
        }
      }
    }
    .swiper{
      // padding: 0px 50px;
      overflow: hidden;
      .swiper-wrapper{
        .swiper-slide{
          width: auto;
          width: 220px !important;
          // height: 210px;
          background: #FFFFFF;
          border-radius: 16px;
          cursor: pointer;
          .background{
            position: absolute;
            width: 220px;
            height: 140px;
            background: linear-gradient(107.17deg, rgba(20, 195, 147, 0.24) 0%, rgba(20, 195, 147, 0.0576) 51.56%, rgba(20, 195, 147, 0) 100%);
            mix-blend-mode: normal;
            border-radius: 16px;
          }
          img{
            width: 220px;
            height: 140px;
            border-radius: 16px;
          }
          .twoline{
            height: 44px;
            .twoLineIcon{
              color: #8C8CA2;
            }
          }
          p{
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: #0E0E2C;
          }
          .bottom{
            margin-top: 4px;
            p{
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 150%;
              color: #8C8CA2;
            }
            .twoLineIcon{
              width: 16px;
              height: 16px;
              color: #8C8CA2;
              margin-left: 8px;
            }
            img{
              margin-left: 10px;
              border-radius: 0px !important;
            }
            align-items: center;
            display: flex;
          }
        }
        .swiper-slide:hover{
          .background{
            background: none;
          }
          .twoline{
              color: #14C393;
            } 
        }
      }
    }
  }
  @media screen and (max-width: 1199px) {
    .newbie{
      .tab{
        margin-block: 36px;
      }
    }
  }
  @media screen and (max-width: 743px) {
    .newbie{
      padding-top: 40px !important;
      .title{
        font-size: 24px;
        line-height: 134%;
      }
      .tab{
        .tabItem{
          font-size: 16px;
          line-height: 150%;
        }
      }
    }
  }

</style>